import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { Tooltip } from 'react-mt-bootstrap'

import { toRoman } from 'helpers'
import { upgradeAvailability } from 'helpers/stronghold'
import { COMMAND_CENTER_TITLE, LEVEL_STRING } from 'helpers/i18n.jsx'

import { UPGRADE_AVAILABLE, BUILDING_INFO } from './constants.jsx'
import { COMMAND_CENTER_TOOLTIP_ID } from 'constants'

import styles from './CommandCenterTooltip.scss'

export class CommandCenterTooltip extends React.Component {
    static propTypes = {
        level: PropTypes.number.isRequired,
        isUpgradeAvailable: PropTypes.bool.isRequired,
    };
    render() {
        const { level } = this.props
        const upgradeAvailable = this.props.isUpgradeAvailable ? (
      <div>
        <div className={styles.divider} />
        <div
            className={classNames(
            styles.statusMessage,
            styles.statusMessage__positive
          )}
        >
          <p className={styles.status}>{UPGRADE_AVAILABLE}</p>
        </div>
      </div>
    ) : null
        return (
      <Tooltip id={COMMAND_CENTER_TOOLTIP_ID}>
        <div className={styles.base}>
          <div className={styles.header}>
            <p className={styles.title}>{COMMAND_CENTER_TITLE}</p>
            <p className={styles.level}>{LEVEL_STRING(level)}</p>
          </div>
          <div className={styles.info}>
            <p>
              {BUILDING_INFO(
                <span className={styles.infoLevel}>{toRoman(level)}</span>
              )}
            </p>
          </div>
          {upgradeAvailable}
        </div>
      </Tooltip>
        )
    }
}

export const mapStateToProps = state => {
    return {
        isUpgradeAvailable: upgradeAvailability(state),
    }
}

export default connect(mapStateToProps)(CommandCenterTooltip)



// WEBPACK FOOTER //
// ./components/CommandCenterTooltip/CommandCenterTooltip.jsx